realContentType